export default {
  read: {
    title: "Blog",
    subtitle: "Set up your blog",
    content: {
      title: "Articles",
      subtitle: "Create your articles"
    },
    table: {
      headers: {
        title: "Article",
        status: "Status",
        date: "Publish date",
        actions: "Actions"
      },
      item: {
        status: {
          enabled: "Enabled",
          disabled: "Disabled"
        }
      }
    },
    newArticle: "New article"
  },
  create: {
    title: "Create article",
    subtitle: "Complete your blog with new articles",
    form: {
      article: "Article",
      title: "Title",
      subtitle: "First impressions are what matters",
      description: "Description",
      mainImg: "Image",
      status: "Status",
      publish: "Publicar",
      submit: "Save",
      cancel: "Cancel",
      delete: "Delete"
    }
  }
};
